// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__4wY2Q","header":"ReportDetails_header__1m3rk","title":"ReportDetails_title__xOy7m","left":"ReportDetails_left__2R-2l"};